/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CodeDefinition } from '../models/CodeDefinition';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CodeDefinitionsService {

    /**
     * @returns CodeDefinition
     * @throws ApiError
     */
    public static codeDefinitionsList({
        category,
        categoryIn,
        ordering,
    }: {
        category?: string,
        /**
         * Multiple values may be separated by commas.
         */
        categoryIn?: Array<string>,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
    }): CancelablePromise<Array<CodeDefinition>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/code-definitions/',
            query: {
                'category': category,
                'category__in': categoryIn,
                'ordering': ordering,
            },
        });
    }

}
